import {Spin} from "antd";
import React from "react";
import { ClipLoader } from "react-spinners";
import {MOBCOLORS} from "../../configs/AppConfig";


export function MobSpin({children,spinning,large})
{

    return(
        <Spin
            spinning={spinning}
            style={{}}
            indicator={(
                <ClipLoader
                    color={MOBCOLORS.cyan.color}
                    loading={true}
                    size={30}
                />
            )}
        >
            {children}
        </Spin>
    )
}